import lj from '../lumberjack';

lj.setupLJ();

$(document).ready(function() {
  const bannerBtn = $('#apay-signup-btn');
  const getStartedBtn = $('#apay-get-started-btn');
  const tableTabs = $('#tabs-table .tab');
  const tableTabsBody = $('#tabs-table .tab-data');

  $(bannerBtn).click(function() {
    lj.pushEvents({
      event_name: 'website.payouts_apay_signup',
      event_type: 'initiated'
    });
  });
  $(getStartedBtn).click(function() {
    lj.pushEvents({
      event_name: 'website.payouts_apay_get_started',
      event_type: 'initiated'
    });
  });

  $('#tabs-table .tab').on('click', function(event) {
    const elementId = event.currentTarget.getAttribute('href');
    for (let index = 0; index < tableTabs.length; index++) {
      if (tableTabs[index].classList.contains('active')) {
        tableTabs[index].classList.remove('active');
      }
      if (tableTabsBody[index].classList.contains('active')) {
        tableTabsBody[index].classList.remove('active');
      }
    }
    event.currentTarget.classList.add('active');
    document.getElementById(elementId).classList.add('active');
  });
});
